// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1NvWV","cell":"ColumnAccessor_cell__3XNoB","firstCellAccent":"ColumnAccessor_firstCellAccent__1N1L3"};